import React, {
  useState, useEffect,
} from 'react';
import PropTypes from 'prop-types';
import Label from '../label/label';
import './textScroll.scss';

/**
 * Basic HTML input
 */
const TextScroll = (props) => {
  const {
    label,
    helpText,
    value,
  } = props;

  const [valueState, setValueState] = useState([]);

  useEffect(() => {
    if (value.length > 0) {
      setValueState(value);
    }
  }, [value]);


  return (
    <div className="form-group row ">
      { label !== ''
        && (
          <Label helpText={helpText}>{label}</Label>
        )}
      <div className="col-sm-8" style={{}}>
        <div className=" scroll-container">
          {
             valueState.map((e, i) => (
               <div key={i}>
                 <div className="scroll-container-item">{e}</div>
               </div>
             ))
          }
        </div>

      </div>
    </div>
  );
};

TextScroll.propTypes = {
  value: PropTypes.node,
  helpText: PropTypes.string,
  label: PropTypes.string,
  /**
   * Function to bind onChange HTML functionality
   */
  onChange: PropTypes.func,
};

TextScroll.defaultProps = {
  value: '',
  helpText: '',
  label: '',
  onChange: () => {},
};

export default TextScroll;
